/**
 * these inline attributes are needed for the correct display of the content in email clients
 */
export const addInlineWidthAttributeToImages = (html: string) => {
  const imageMatches = html.match(/<img([\w\W]+?)>/g)
  imageMatches?.forEach((image) => {
    if (!image.includes('width=')) {
      html = html.replace(
        image,
        image.replace(/<img src/g, '<img width="600" src') // quill uses the inline width attribute when scaling images, using a style attribute is not compatible with quill
      )
    }
  })

  return html
}
